import { Outlet } from "react-router-dom";
import ErrorBoundary from "../api/ErrorBoundary";
import SeoLoader from "../components/seo/SeoLoader";
import PaymentNavbar from "../components/navbar/navbarComponents/PaymentNavbar";
import { Suspense } from "react";

const PaymentLayout = () => (
  <div className="simple-layout">
    <ErrorBoundary>
      <SeoLoader />
      <Suspense>
        <PaymentNavbar />
        <Outlet />
      </Suspense>
    </ErrorBoundary>
  </div>
);

export default PaymentLayout;
